import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Header from "../Components/Header";

function Dashboard() {
    const [tasks, setTasks] = useState([]);
    const [title, setTitle] = useState("");
    const [dueDate, setDueDate] = useState("");

    const [editId, setEditId] = useState(null);
    const [editText, setEditText] = useState("");
    const [editDate, setEditDate] = useState("");

    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState("all");

    const [darkMode, setDarkMode] = useState(
        localStorage.getItem("theme") === "dark"
    );

    const API = process.env.REACT_APP_API_URL;

    const token = localStorage.getItem("token");
    
    const fetchTasks = useCallback(async () => {
        try {
            const res = await axios.get(`${API}/api/tasks`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTasks(res.data);
        } catch (err) {
            console.log(err);
        }
    }, [API, token]);

    useEffect(() => {
        if (!token) window.location.href = "/";
        else fetchTasks();
    }, [token, fetchTasks]);

    // 🌙 SAVE THEME
    useEffect(() => {
        localStorage.setItem("theme", darkMode ? "dark" : "light");
    }, [darkMode]);


    // ✅ ADD TASK (FIXED)
    const addTask = async () => {
        if (!title.trim()) return;
        console.log("Sending:", { title, dueDate });
        await axios.post(
            `${API}/api/tasks`,
            {
                title,
                dueDate: dueDate ? dueDate : null   // 🔥 FIX
            },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        setTitle("");
        setDueDate("");
        fetchTasks();
    };

    const deleteTask = async (id) => {
        await axios.delete(`${API}/api/tasks/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        fetchTasks();
    };

    const toggleStatus = async (task) => {
        await axios.put(
            `${API}/api/tasks/${task._id}`,
            {
                status: task.status === "pending" ? "completed" : "pending"
            },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        fetchTasks();
    };

    const startEdit = (task) => {
        setEditId(task._id);
        setEditText(task.title);
        setEditDate(task.dueDate ? task.dueDate.split("T")[0] : "");
    };
    console.log(tasks);

    // ✅ SAVE EDIT FIXED
    const saveEdit = async (id) => {
        await axios.put(
            `${API}/api/tasks/${id}`,
            {
                title: editText,
                dueDate: editDate || null   // 🔥 FIX
            },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        setEditId(null);
        setEditText("");
        setEditDate("");
        fetchTasks();
    };

    const logout = () => {
        localStorage.removeItem("token");
        window.location.href = "/";
    };

    const filteredTasks = tasks.filter((task) => {
        const matchesSearch = task.title
            .toLowerCase()
            .includes(search.toLowerCase());

        const matchesFilter =
            filter === "all" || task.status === filter;

        return matchesSearch && matchesFilter;
    });

    return (
        <div style={{
            minHeight: "100vh",
            background: darkMode ? "#121212" : "#f4f6f8",
            color: darkMode ? "#fff" : "#000"
        }}>

            {/* ✅ GLOBAL HEADER */}
            <Header
                title="Dashboard"
                darkMode={darkMode}
                setDarkMode={setDarkMode}
                isLoggedIn={true}
                logout={logout}
            />

            <div style={{
                display: "flex",
                justifyContent: "center",
                padding: "30px"
            }}>
                <div style={{
                    background: darkMode ? "#1e1e1e" : "#fff",
                    padding: "20px",
                    width: "100%",
                    maxWidth: "500px",
                    borderRadius: "10px"
                }}>

                    {/* ADD TASK */}
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                        <input
                            placeholder="New Task"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            style={{ flex: 1, padding: "8px" }}
                        />

                        <input
                            type="date"
                            value={dueDate}
                            onChange={(e) => setDueDate(e.target.value)}
                        />

                        <button onClick={addTask}>Add</button>
                    </div>

                    {/* SEARCH */}
                    <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                        <input
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{ flex: 1, padding: "8px" }}
                        />

                        <select onChange={(e) => setFilter(e.target.value)}>
                            <option value="all">All</option>
                            <option value="pending">Pending</option>
                            <option value="completed">Completed</option>
                        </select>
                    </div>

                    {/* TASK LIST */}
                    <div style={{ marginTop: "20px" }}>
                        {filteredTasks.map((task) => {

                            const isOverdue =
                                task.dueDate &&
                                new Date(task.dueDate) < new Date() &&
                                task.status === "pending";

                            return (
                                <div key={task._id} style={{
                                    border: "1px solid #ddd",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "10px"
                                }}>

                                    {editId === task._id ? (
                                        <>
                                            <input
                                                value={editText}
                                                onChange={(e) => setEditText(e.target.value)}
                                            />
                                            <input
                                                type="date"
                                                value={editDate}
                                                onChange={(e) => setEditDate(e.target.value)}
                                            />
                                            <button onClick={() => saveEdit(task._id)}>Save</button>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{
                                                textDecoration: task.status === "completed" ? "line-through" : "none"
                                            }}>
                                                {task.title}
                                            </p>

                                            {/* ✅ FIXED DATE */}
                                            <small style={{
                                                display: "block",
                                                marginTop: "5px",
                                                color: isOverdue ? "red" : "#555"
                                            }}>
                                                📅 Due: {
                                                    task.dueDate && !isNaN(new Date(task.dueDate))
                                                        ? new Date(task.dueDate).toLocaleDateString()
                                                        : "No due date"
                                                }
                                            </small>

                                            {isOverdue && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    ⚠ Overdue
                                                </span>
                                            )}

                                            <br />

                                            <span style={{
                                                background: task.status === "completed" ? "green" : "orange",
                                                color: "#fff",
                                                padding: "3px 8px",
                                                borderRadius: "5px"
                                            }}>
                                                {task.status}
                                            </span>

                                            <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                                <button onClick={() => toggleStatus(task)}>
                                                    {task.status === "pending" ? "Done" : "Undo"}
                                                </button>

                                                <button onClick={() => startEdit(task)}>Edit</button>

                                                <button onClick={() => deleteTask(task._id)}>
                                                    Delete
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;